export const IS_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const CONTAINS_PARENTHESES_PAIRS = /([()])/;
export const MATCH_ANYTHING_IN_PARENTHESES = /(?<=\().+?(?=\))/;
export const MATCH_UP_TO_FIRST_PARENTHESE = /[^(]*/;